import DocumentOutputLocation, { DocumentOutputLocationStatus } from 'models/documentOutputLocation';

/** Where the report of one audit is written: the audit reports location with its check, and the audit's folder. */
export default class InternalAuditReportSettings {
  location: DocumentOutputLocation;

  status: DocumentOutputLocationStatus;

  /** Set once the audit entered Preparing, when its folder is created in the location. */
  folderDriveItemId?: string;

  folderName?: string;

  folderUrl?: string;

  constructor() {
    this.location = new DocumentOutputLocation();
    this.status = new DocumentOutputLocationStatus();
  }
}
